import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { useHistory, useLocation } from 'react-router';
import { createStructuredSelector } from 'reselect';
import { selectPlanningAction, resetStateAction } from '../../actions';
import { removeModalQuery } from '../../../../utils/removeModalQuery';
import closeModal from '../../../../utils/closeModal';
import { getIsPlanningSelectedSelector } from '../../selectors';

const SelectCellWrapper = ({ rowData, onSelectPlanning, onResetState, isPlanningSelected }) => {
	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	const handleModalClose = () => {
		closeModal(query);
		onResetState();
		history.push(`${pathname}?${query}`);
	};

	const handleCheckboxChange = () => {
		onSelectPlanning({
			planning_id: rowData.id,
			searchQuery: removeModalQuery(query.toString()),
			redirect: handleModalClose,
		});
	};

	if (rowData?.actions && rowData?.actions?.select) {
		return (
			<Button
				disabled={!!isPlanningSelected}
				loading={isPlanningSelected && isPlanningSelected === rowData.id}
				className="custom-cell-process__button"
				onClick={() => handleCheckboxChange()}
			>
				Выбрать
			</Button>
		);
	}

	return null;
};

const mapDispatchToProps = {
	onResetState: resetStateAction,
	onSelectPlanning: selectPlanningAction,
};

const mapStateToProps = createStructuredSelector({
	isPlanningSelected: getIsPlanningSelectedSelector(),
});

SelectCellWrapper.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string,
	onSelectPlanning: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	isPlanningSelected: PropTypes.any,
};

const SelectCell = connect(mapStateToProps, mapDispatchToProps)(SelectCellWrapper);

export { SelectCell };
